import Types from '../Types'

export default (page, payload = {}) => ({
    type: Types.APP.CHANGEPAGE,
    page,
    payload
})



// WEBPACK FOOTER //
// ./src/actions/app/ChangePageAction.js